/* ESPEJOL · Ficha de producto */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  root.classList.add('js-ep');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = window.matchMedia('(min-width: 990px)');
  function each(l, f) { Array.prototype.forEach.call(l, f); }
  function behavior() { return reduce ? 'auto' : 'smooth'; }

  function gtagWA(scope) {
    each(scope.querySelectorAll('a[href*="wa.me"]'), function (a) {
      a.addEventListener('click', function () {
        if (typeof window.gtag === 'function') window.gtag('event', 'conversion', { send_to: 'AW-16897459775/MaqYCIH_qLAaEL-Mq_k-' });
      });
    });
  }

  function Gallery(rootEl, api) {
    var track = rootEl.querySelector('[data-ep-track]');
    if (!track) return null;
    var slides = track.querySelectorAll('[data-ep-slide]');
    var thumbs = rootEl.querySelectorAll('[data-ep-thumb]');
    var bars = rootEl.querySelectorAll('[data-ep-bar]');
    var count = rootEl.querySelector('[data-ep-count]');
    var prev = rootEl.querySelector('[data-ep-prev]');
    var next = rootEl.querySelector('[data-ep-next]');
    var index = 0, raf = null;

    each(track.querySelectorAll('img'), function (img) {
      if (img.complete) img.classList.add('is-loaded');
      else img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
    });

    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function set(i) {
      index = i;
      each(thumbs, function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      each(bars, function (b, k) { b.classList.toggle('is-active', k === i); });
      if (count) count.textContent = pad(i + 1) + ' / ' + pad(slides.length);
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      each(slides, function (s, k) { if (k !== i) s.classList.remove('is-zoomed'); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      var t = thumbs[i];
      if (t && t.parentNode.scrollWidth > t.parentNode.clientWidth) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: behavior() });
    }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft, behavior: behavior() });
      set(i);
    }
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var w = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        if (i !== index) set(i);
      });
    }, { passive: true });
    each(thumbs, function (t, k) { t.addEventListener('click', function () { go(k); }); });
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
    });

    each(slides, function (s, k) {
      if (!s.classList.contains('ep-slide--img')) return;
      var img = s.querySelector('img');
      s.addEventListener('click', function (e) {
        if (!desktop.matches) { api.openLightbox(k); return; }
        var on = !s.classList.contains('is-zoomed');
        s.classList.toggle('is-zoomed', on);
        if (on) move(e);
      });
      function move(e) {
        var r = s.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top) / r.height) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
      }
      s.addEventListener('mousemove', function (e) { if (s.classList.contains('is-zoomed')) move(e); });
      s.addEventListener('mouseleave', function () { s.classList.remove('is-zoomed'); });
    });

    var start = parseInt(rootEl.getAttribute('data-ep-start') || '0', 10) || 0;
    if (start > 0) { track.scrollLeft = slides[start] ? slides[start].offsetLeft : 0; }
    set(start);
    return {
      goToMedia: function (id) {
        if (!id) return;
        for (var k = 0; k < slides.length; k++) { if (slides[k].getAttribute('data-media-id') === String(id)) { go(k); return; } }
      },
      index: function () { return index; }
    };
  }

  function Lightbox(rootEl) {
    var lb = rootEl.querySelector('[data-ep-lb]');
    if (!lb) return { open: function () {} };
    var track = lb.querySelector('[data-ep-lb-track]');
    var count = lb.querySelector('[data-ep-lb-count]');
    var built = false, opener = null, slides = [];
    var sources = rootEl.querySelectorAll('[data-ep-full]');
    function build() {
      if (built) return; built = true;
      each(sources, function (src) {
        var s = d.createElement('div'); s.className = 'ep-lb__slide';
        var img = d.createElement('img'); img.src = src.getAttribute('data-ep-full'); img.alt = src.getAttribute('data-ep-alt') || ''; img.decoding = 'async';
        s.appendChild(img); track.appendChild(s); slides.push(s);
      });
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
        if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      }, { passive: true });
    }
    function step(dir) {
      var i = Math.round(track.scrollLeft / (track.clientWidth || 1)) + dir;
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: behavior() });
    }
    function close() {
      lb.classList.remove('is-open'); lb.setAttribute('aria-hidden', 'true'); root.classList.remove('ep-lock');
      d.removeEventListener('keydown', onKey);
      if (opener) opener.focus();
    }
    function onKey(e) {
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') step(1);
      if (e.key === 'ArrowLeft') step(-1);
    }
    lb.querySelector('[data-ep-lb-close]').addEventListener('click', close);
    var p = lb.querySelector('[data-ep-lb-prev]'), n = lb.querySelector('[data-ep-lb-next]');
    if (p) p.addEventListener('click', function () { step(-1); });
    if (n) n.addEventListener('click', function () { step(1); });
    return {
      open: function (i) {
        build(); opener = d.activeElement;
        if (!slides.length) return;
        lb.classList.add('is-open'); lb.setAttribute('aria-hidden', 'false'); root.classList.add('ep-lock');
        i = Math.max(0, Math.min(slides.length - 1, i || 0));
        track.scrollLeft = i * track.clientWidth;
        if (count) count.textContent = (i + 1) + ' / ' + slides.length;
        d.addEventListener('keydown', onKey);
        lb.querySelector('[data-ep-lb-close]').focus();
      }
    };
  }

  function initProduct(rootEl) {
    var jsonEl = rootEl.querySelector('[data-ep-json]');
    var data = { variants: [] };
    try { data = JSON.parse(jsonEl.textContent); } catch (e) {}
    var lightbox = Lightbox(rootEl);
    var gallery = Gallery(rootEl, { openLightbox: function (i) { lightbox.open(i); } });
    each(rootEl.querySelectorAll('[data-ep-open]'), function (b) {
      b.addEventListener('click', function () {
        var i = b.getAttribute('data-ep-open');
        lightbox.open(i === 'current' ? (gallery ? gallery.index() : 0) : parseInt(i, 10));
      });
    });

    var form = rootEl.querySelector('form[action*="/cart/add"]');
    var idInput = form ? form.querySelector('[data-ep-variant]') : null;
    var fieldsets = form ? form.querySelectorAll('[data-ep-option]') : [];
    var priceEls = rootEl.querySelectorAll('[data-ep-price]');
    var wasEls = rootEl.querySelectorAll('[data-ep-was]');
    var avail = rootEl.querySelector('[data-ep-avail]');
    var addBtns = rootEl.querySelectorAll('[data-ep-add]');
    var status = rootEl.querySelector('[data-ep-status]');
    var t = data.i18n || {};

    function selected() {
      return Array.prototype.map.call(fieldsets, function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
    }
    function match(opts) {
      return data.variants.filter(function (v) { return v.options.every(function (o, i) { return opts[i] == null || o === opts[i]; }); })[0];
    }
    function markAvailability() {
      var sel = selected();
      each(fieldsets, function (fs, i) {
        each(fs.querySelectorAll('input'), function (inp) {
          var trial = sel.slice(); trial[i] = inp.value;
          var v = match(trial);
          inp.closest('.ep-chip').classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    function render(v, moveGallery) {
      each(fieldsets, function (fs) {
        var c = fs.querySelector('input:checked'), l = fs.querySelector('[data-ep-option-value]');
        if (c && l) l.textContent = c.getAttribute('data-label') || c.value;
      });
      markAvailability();
      each(addBtns, function (b) {
        var ok = !!(v && v.available);
        b.disabled = !ok;
        var l = b.querySelector('[data-ep-add-label]');
        if (l) l.textContent = ok ? t.add : (v ? t.soldout : t.unavailable);
      });
      if (!v) return;
      if (idInput) idInput.value = v.id;
      each(priceEls, function (p) { p.textContent = v.price; });
      each(wasEls, function (w) { w.textContent = v.compare || ''; w.hidden = !v.compare; });
      if (avail) { avail.setAttribute('data-state', v.state); avail.textContent = t[v.state] || ''; }
      if (moveGallery && gallery && v.media) gallery.goToMedia(v.media);
      try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState(window.history.state, '', u.toString()); } catch (e) {}
    }
    if (form) {
      form.addEventListener('change', function (e) { if (e.target.closest('[data-ep-option]')) render(match(selected()), true); });
      markAvailability();

      form.addEventListener('submit', function (e) {
        if (!window.fetch || !idInput) return;
        e.preventDefault();
        var drawer = d.querySelector('cart-drawer');
        var drawerSection = drawer && drawer.closest('.shopify-section') ? drawer.closest('.shopify-section').id.replace('shopify-section-', '') : null;
        var body = { items: [{ id: Number(idInput.value), quantity: 1 }] };
        if (drawerSection) { body.sections = [drawerSection]; body.sections_url = window.location.pathname; }
        each(addBtns, function (b) { b.setAttribute('aria-busy', 'true'); });
        if (status) status.textContent = '';
        fetch((data.routes && data.routes.add || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body)
        }).then(function (r) {
          return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || t.error); return j; });
        }).then(function (res) {
          return fetch((data.routes && data.routes.cart || '/cart') + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) { return { res: res, cart: cart }; });
        }).then(function (o) {
          each(d.querySelectorAll('.cart-link__count'), function (el) { el.textContent = o.cart.item_count; });
          var opened = false;
          try {
            if (drawer && o.res.sections && o.res.sections[drawerSection] && typeof drawer.updateFromCartChange === 'function') {
              drawer.updateFromCartChange(o.res.sections[drawerSection]);
              d.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { detail: { opener: addBtns[0] } }));
              opened = true;
            }
          } catch (err) { opened = false; }
          if (status) {
            status.textContent = t.added + ' \u00b7 ';
            var a = d.createElement('a'); a.href = (data.routes && data.routes.cart) || '/cart'; a.textContent = t.viewCart;
            status.appendChild(a);
          }
        }).catch(function (err) {
          if (status) status.textContent = err.message || t.error;
        }).then(function () {
          each(addBtns, function (b) { b.removeAttribute('aria-busy'); });
        });
      });
    }

    var bar = rootEl.querySelector('[data-ep-bar]');
    var mainBtn = rootEl.querySelector('.ep-buy [data-ep-add]');
    if (bar && mainBtn && 'IntersectionObserver' in window) {
      var footerVisible = false, pastBtn = false;
      function sync() {
        var show = pastBtn && !footerVisible && !desktop.matches;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        each(bar.querySelectorAll('button'), function (b) { b.tabIndex = show ? 0 : -1; });
        root.classList.toggle('ep-bar-on', show);
      }
      new IntersectionObserver(function (es) {
        es.forEach(function (en) { pastBtn = !en.isIntersecting && en.boundingClientRect.top < 0; });
        sync();
      }).observe(mainBtn);
      var foot = d.querySelector('#pagefooter, footer');
      if (foot) new IntersectionObserver(function (es) { es.forEach(function (en) { footerVisible = en.isIntersecting; }); sync(); }).observe(foot);
    }
    gtagWA(rootEl);
  }

  function initRecs(el) {
    if (el.querySelector('[data-ep-card]')) return;
    var url = el.getAttribute('data-url');
    if (!url || !window.fetch) return;
    function load(intent) {
      return fetch(url + '&intent=' + intent).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = d.createElement('div'); tmp.innerHTML = html;
        var inner = tmp.querySelector('[data-ep-recs]');
        return inner && inner.querySelector('[data-ep-card]') ? inner.innerHTML : null;
      });
    }
    load('complementary').then(function (h) { return h || load('related'); }).then(function (h) { if (h) el.innerHTML = h; }).catch(function () {});
  }

  function init() {
    each(d.querySelectorAll('[data-ep]'), initProduct);
    var recs = d.querySelectorAll('[data-ep-recs]');
    if (recs.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { io.unobserve(en.target); initRecs(en.target); } }); }, { rootMargin: '400px 0px' });
      each(recs, function (r) { io.observe(r); });
    } else { each(recs, initRecs); }
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
